<template>
  <div>
    <div v-if="!disableForm">
      <validation-observer ref="form">
        <b-form @submit.prevent>
          <b-row>
            <!-- Tipo de Pagamento -->
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="tipo de pagamento"
                rules=""
              >
                <b-form-group label="Tipo de Pagamento" label-for="v-tipo-pagamento">
                  <v-select
                    id="v-tipo-pagamento"
                    v-model="paymentConfig.tipoPagamento"
                    label="descricao"
                    :options="comboTipoPagamento"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Selecione o tipo de pagamento"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Conta -->
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="conta"
                rules=""
              >
                <b-form-group label="Conta" label-for="v-conta">
                  <v-select
                    id="v-conta"
                    v-model="paymentConfig.conta"
                    label="descricao"
                    :options="comboContas"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Selecione a conta"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Forma de Pagamento -->
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="forma de pagamento"
                rules=""
              >
                <b-form-group label="Forma de Pagamento" label-for="v-forma-pagamento">
                  <v-select
                    id="v-forma-pagamento"
                    v-model="paymentConfig.formaPagamento"
                    label="descricao"
                    :options="comboFormasPagamento"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Selecione a forma de pagamento"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Principal -->
            <b-col md="6">
              <div style="margin-top: 30px">
                <b-form-checkbox
                  v-model="paymentConfig.principal"
                  :value="true"
                  class="custom-control-primary"
                >
                  Configuração Principal
                </b-form-checkbox>
                <small class="text-muted d-block mt-1">Se marcada, esta configuração será usada preferencialmente para este sócio.</small>
              </div>
            </b-col>

            <b-col cols="12" class="mt-2">
              <ButtonsFormVue
                :permission-insert="verificarPermissao('ROLE_ADMIM_INSERIR')"
                :permission-edit="verificarPermissao('ROLE_ADMIM_ATUALIZAR')"
                :disable-form="false"
                @save="save()"
                @cancel="cancel()"
              />
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <div v-else>
      <div class="custom-search d-flex justify-content-start mb-2">
        <b-button
          v-if="verificarPermissao('ROLE_ADMIM_ATUALIZAR')"
          variant="primary"
          @click="novaConfig()"
        >
          Incluir Configuração
        </b-button>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="listaPaymentConfigs"
        :rtl="direction"
        styleClass="vgt-table striped"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'principal'">
            <b-badge :variant="props.row.principal ? 'light-success' : 'light-secondary'">
              {{ props.row.principal ? 'Sim' : 'Não' }}
            </b-badge>
          </span>
          <span v-else-if="props.column.field === 'action'">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle"
                />
              </template>
              <b-dropdown-item @click="editConfig(props.row)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Editar</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="verificarPermissao('ROLE_ADMIM_DELETAR')"
                @click="deleteConfig(props.row)"
              >
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Excluir</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import mixinsGlobal from '@/mixins'
import {
  BForm,
  BFormGroup,
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
  BBadge
} from 'bootstrap-vue'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import { verificarPermissao } from '@/auth/utils'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButton,
    BFormCheckbox,
    BDropdown,
    BDropdownItem,
    BBadge,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    VueGoodTable,
    ButtonsFormVue
  },
  directives: {
    Ripple
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('paymentConfigSettingsModule', {
      listaPaymentConfigs: (state) => state.listaPaymentConfigs,
      paymentConfig: (state) => state.paymentConfig
    }),
    ...mapState('registrationTypeSettingsModule', {
      comboTipoPagamento: (state) => state.comboTipoPagamento,
      comboContas: (state) => state.comboContas,
      comboFormasPagamento: (state) => state.comboFormasPagamento
    }),
    direction() {
      return store.state.appConfig.isRTL
    }
  },
  async mounted() {
    this.loadTable()
    this.$store.dispatch('registrationTypeSettingsModule/loadComboTipoPagamento')
    this.$store.dispatch('registrationTypeSettingsModule/loadComboContas')
    this.$store.dispatch('registrationTypeSettingsModule/loadComboFormasPagamento')
  },
  methods: {
    verificarPermissao,
    novaConfig() {
      this.$store.commit('paymentConfigSettingsModule/RESET_PAYMENT_CONFIG')
      this.disableForm = false
    },
    editConfig(data) {
      // Clonar para evitar mutação direta
      const clone = JSON.parse(JSON.stringify(data))
      this.$store.commit('paymentConfigSettingsModule/SET_PAYMENT_CONFIG', clone)
      this.disableForm = false
    },
    cancel() {
      this.$store.commit('paymentConfigSettingsModule/RESET_PAYMENT_CONFIG')
      this.disableForm = true
    },
    loadTable() {
      this.$store.dispatch('paymentConfigSettingsModule/fetchConfigs', this.$route.params.id)
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          const payload = {
            ...this.paymentConfig,
            registroId: this.$route.params.id
          }
          this.$store.dispatch('paymentConfigSettingsModule/saveConfig', payload)
            .then(() => {
              this.showMessageSuccess('Salvo', 'Configuração salva com sucesso!')
              this.cancel()
            })
            .catch((error) => {
              const errorMsg = error.response?.data?.message || 'Erro ao salvar configuração'
              this.MensagemError('Falha', errorMsg)
            })
        }
      })
    },
    deleteConfig(data) {
      this.$swal({
        title: 'Remover configuração?',
        text: 'O sistema voltará a usar o padrão da categoria para este sócio.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Remover',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('paymentConfigSettingsModule/deleteConfig', data.id)
            .then(() => {
              this.loadTable()
              this.showMessageSuccess('Remover', 'Removido com sucesso!')
            })
        }
      })
    }
  },
  data() {
    return {
      required,
      disableForm: true,
      columns: [
        {
          label: 'Tipo de Pagamento',
          field: 'tipoPagamento.descricao'
        },
        {
          label: 'Conta',
          field: 'conta.descricao'
        },
        {
          label: 'Forma de Pagamento',
          field: 'formaPagamento.descricao'
        },
        {
          label: 'Principal',
          field: 'principal'
        },
        {
          label: 'Ações',
          field: 'action'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
